import styled from 'styled-components';
import { States } from './constants';
export var LoadingRoot = styled.div.withConfig({
  displayName: "styles__LoadingRoot",
  componentId: "sc-1ui2le5-0"
})(["", " & path{stroke:", ";}"], function (props) {
  return props.state === States.Loading && 'transform: scaleY(-1);';
}, function (props) {
  return props.color;
});